<template>
  <div class="at-chat_sidebar">
    <guppy-chat-header :isWidgetChat="isWidgetChat"/>
    <guppy-caht-user-list v-if="activeTab == 'contacts'" />
    <guppy-chat-conversation-list  @getUserMessageEvent="getMessageEvent( $event )"  v-else-if="activeTab == 'messages'"  />
    <guppy-chat-friend-list :TabProps="activeTab"  v-else-if="activeTab == 'friends'" />
    <guppy-chat-block-user-list :TabProps="activeTab" v-else-if="activeTab == 'blocked'" />
    <guppy-chat-posts-conversation-list :TabProps="activeTab" v-else-if="activeTab == 'posts'" />
    <guppy-chat-sidebar-footer />
  </div>
</template>

<script>
import GuppyChatConversationList  from "./GuppyChatConversationList/GuppyChatConversationList.vue";
import GuppyChatPostsConversationList  from "./GuppyChatPostsConversationList/GuppyChatPostsConversationList.vue";
import GuppyChatSidebarFooter     from "./GuppyChatSidebarFooter/GuppyChatSidebarFooter.vue";
import GuppyChatBlockUserList     from "./GuppyChatBlockUserList/GuppyChatBlockUserList.vue";
import GuppyChatHeader            from "./GuppySidebarHeader/GuppyChatHeader.vue";
import GuppyCahtUserList          from "./GuppyChatUsersList/GuppyChatUsersList.vue";
import GuppyChatFriendList        from "./GuppyChatFriendList/GuppyChatFriendList.vue";
import { GUPPYCHAT_SETTINGS }     from "./../../resources/constants";
import RestApiManager from "../../resources/RestApiController";
import { mapState } from 'vuex';
export default {
    name : "GuppyChatSidebar",
    components: {
      GuppyChatHeader,
      GuppyCahtUserList,
      GuppyChatSidebarFooter,
      GuppyChatConversationList,
      GuppyChatFriendList,
      GuppyChatBlockUserList,
      GuppyChatPostsConversationList
    },
    props:{
      isWidgetChat : {
				type : Boolean,
				required : false,
				default : false
			}
    },
    data(){
      return{
        Tab : 'users'
      }
    },
    computed :mapState({
      isEmptyView: state => state.isEmptyView,
      isOpenMessagesScr: state => state.isOpenMessagesScr,
      activeTab: state => state.activeTab,
    }),
    beforeCreate(){
      this.$store.commit('selectTab', GUPPYCHAT_SETTINGS.defaultActiveTab);
      
    },
    created(){
      RestApiManager.getUnReadMessages()
    }
}
</script>
<style scoped>
.at-chat_sidebar {
  position: relative;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 25%;
  flex: 0 0 25%;
  max-width: 25%;
}
</style>